import React, { useContext, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AuthContext } from "../authProvider/authProvider";
import { getAuth, signOut } from "firebase/auth";
import TableChartIcon from "@mui/icons-material/TableChart";

interface CardProps {
  title: string;
  content: string;
  IconComponent: React.ReactNode;
  onCardClick: () => void;
  tooltipText: string;
}

const Card: React.FC<CardProps> = ({ title, content, IconComponent, onCardClick, tooltipText }) => {
  return (
    <div className="card" onClick={onCardClick}>
      <span className="tooltip">{tooltipText}</span>
      <h2>{title}</h2>
      <div className="card-iconHome">{IconComponent}</div>
      <p>{content}</p>
    </div>
  );
};

const auth = getAuth();

const FormSubmissions: React.FC = () => {
  const authContext = useContext(AuthContext); // Get Auth context
  const [loading, setLoading] = useState(true); // Track loading state
  const [needAssignment, setNeedAssignmnent] = useState(true);
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }

  const { currentUser, suspended } = authContext;

  const navigate = useNavigate();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const goToACH = () => {
    navigate("/formSubmissions/ach");
  };

  const gotToAgentIntake = () => {
    navigate("/formSubmissions/agentIntake");
  };
  const goToCUE = () => {
    navigate("/formSubmissions/cue");
  };
  const goToGIF = () => {
    navigate("/formSubmissions/gif");
  };
  const goToGIS = () => {
    navigate("/formSubmissions/gis");
  };

  var tk: string;
  currentUser
    ?.getIdToken(false)
    .then((idToken: string) => {
      tk = idToken;
    })
    .catch((error: any) => {
      console.log(error);
    });

  // If the user is suspended, sign them out and navigate to the login page
  if (suspended === true) {
    signOut(auth)
      .then(() => {
        console.log("Signed out");
        return <Navigate to="/login" />;
      })
      .catch((error) => {
        console.error("Error signing out", error);
      });
  }

  return (
    <div>
      <div className="section">
        <h2 className="section-title">Reports</h2>
        <div className="cards-container">
          <Card
            title="ACH"
            content=""
            IconComponent={<TableChartIcon className="card-iconHome" />}
            onCardClick={goToACH}
            tooltipText=""
          />
          <Card
            title="Agent Intake"
            content=""
            IconComponent={<TableChartIcon className="card-iconHome" />}
            onCardClick={gotToAgentIntake}
            tooltipText=""
          />

          <Card
            title="Contact Us"
            content=""
            IconComponent={<TableChartIcon className="card-iconHome" />}
            onCardClick={goToCUE}
            tooltipText=""
          />
          <Card
            title="GIF"
            content=""
            IconComponent={<TableChartIcon className="card-iconHome" />}
            onCardClick={goToGIF}
            tooltipText=""
          />
          <Card
            title="Group Implementation Survey"
            content=""
            IconComponent={<TableChartIcon className="card-iconHome" />}
            onCardClick={goToGIS}
            tooltipText=""
          />
        </div>
      </div>
    </div>
  );
};

export default FormSubmissions;
